export default "__VITE_ASSET__BYsevgPC__"